export interface LoginRequest {
  login: string;
  password: string;
}

export interface LoginResponse {
  token: string;
}

export interface ResetPasswordRequest {
  password: string;
  token: string;
}

export enum AuthenticationStep {
  LOGIN,
  SET_AUTHENTICATION_TYPE,
  GOOGLE_AUTHENTICATOR_CODE,
  VALIDATE_AUTHENTICATOR_OTP,
  VALIDATE_MOBILE_OTP,
}

export interface UserAccessResponse {
  token: string;
  refreshToken: string;
  expires: number;
  message: string;
}

export interface AuthenticationRefreshRequest {
  refresh_token: string;
}

export enum RefreshState {
  STARTED = "STARTED",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  STALE = "STALE",
  SKIPPED = "SKIPPED",
}
